import { useContext } from 'react'

import { Switch, Route, withRouter } from 'react-router-dom'
import { GlobalContext } from '../../Providers/GlobalProvider'
import InstitutionProvider from '../../Providers/InstitutionProvider'
import MaccsProfilePage from '../../Components/MACCS/ProfilePage/MaccsProfilePage'
import AssistantsReportingView from '../../Views/AssistantReportingView'
import MaccsShiftManagerView from '../../Views/MACCS/ShiftsManager/MaccsShiftsManagerView'
import { isMoment } from 'moment'
import { Routes } from '../../routes'
import ContactPersonsInstitutionMaccs from '../../Views/shared/ContactPersonsView/ContactPersonsInstitutionMaccs'
import MaccsInternshipsProvider from '../../Providers/MaccsInternshipsProvider'
import MaccsInternshipsCalendar from '../../Views/MACCS/MaccsInternshipsManager/MaccsInternshipsCalendar'
import MaccsInternshipMessageProvider from '../../Providers/MaccsinternshipMessageProvider'
import MaccsInstitutionSettings from '../../Views/shared/Settings/MaccsInstitutionSettings'
import InstitutionAssistantsView from '../../Views/MACCS/Assistants/InstitutionAssistantsView'
import SchoolsView from '../../Views/institution/SchoolsView/SchoolsView'

const MaccsInstitutionRouter = ({ history, onLogout }) => {
  const { setCurrentDate } = useContext(GlobalContext)

  const goToShiftManager = date => {
    history.push(Routes.SHIFTS_MANAGER)

    if (isMoment(date)) {
      setCurrentDate(date)
    }
  }

  return (
    <InstitutionProvider>
      <MaccsInternshipMessageProvider>
        <Switch>
          <Route path={Routes.INTERNSHIPS}>
            <MaccsInternshipsProvider>
              <MaccsInternshipsCalendar loadShiftsManager={goToShiftManager} />
            </MaccsInternshipsProvider>
          </Route>
          <Route path={Routes.SHIFTS_MANAGER}>
            <MaccsShiftManagerView />
          </Route>
          <Route path={Routes.PROFILE_PAGE}>
            <MaccsProfilePage onLogout={onLogout} />
          </Route>
          <Route path={Routes.ASSISTANTS}>
            <InstitutionAssistantsView />
          </Route>
          <Route path={Routes.SETTINGS}>
            <MaccsInstitutionSettings />
          </Route>
          <Route path={Routes.BADGES}>
            <AssistantsReportingView />
          </Route>
          <Route path={Routes.SCHOOLS}>
            <SchoolsView />
          </Route>
          <Route path={Routes.CONTACT_PERSONS}>
            <ContactPersonsInstitutionMaccs />
          </Route>
        </Switch>
      </MaccsInternshipMessageProvider>
    </InstitutionProvider>
  )
}

export default withRouter(MaccsInstitutionRouter)
